import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import api from "../../utils/api";
import {toast} from "react-toastify";
import {buildQueryString} from "../../utils/buildQueryString";

const WiseBerryAPIEnv = process.env.VITE_API_KEY;

export const getAllOpenHomes = createAsyncThunk(
  "openHomes/getAllOpenHomes",
  async (obj, {rejectWithValue}) => {
    try {
      let queryString = buildQueryString(obj);
      const res = await api.get(
        `${WiseBerryAPIEnv}appointment?${queryString}&sort_by=starts&type=5&limit=10`
      );
      return res.data;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error("Please Login, Authorization Denied");
      }
      return rejectWithValue(err.message);
    }
  }
);

export const getOpenHomeById = createAsyncThunk(
  "openHome/getOpenHomeById",
  async ({appointmentId, limit = 30, page = 1}, {rejectWithValue}) => {
    try {
      const {data} = await api.get(
        `${WiseBerryAPIEnv}open-home-feedback?appointment=${appointmentId}&limit=${limit}&page=${page}`
      );
      return {data, page};
    } catch (err) {
      if (err.response?.status === 401) {
        toast.error("Please Login, Authorization Denied");
      }
      return rejectWithValue(err.message);
    }
  }
);

let initialState = {
  openHomesData: {
    data: [],
    current_page: 0,
    next_page_url: null,
    first_page_url: null,
    prev_page_url: null,
    from: null,
    to: null,
  },
  loading: false,
  openHomesDataError: null,

  // get open homes by Id
  attendees: {
    data: [],
    current_page: 0,
    next_page_url: null,
    total: 0,
  },
  loadingAttendees: false,
  attendeesError: null,
  formSubmitLoading: false,
  tabIndex: 0,
};

const openHomeSlice = createSlice({
  name: "OpenHomeSlice",
  initialState,
  reducers: {
    setFormSubmitLoading: (state, action) => {
      state.formSubmitLoading = action.payload;
    },
    setTabIndex: (state, action) => {
      state.tabIndex = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllOpenHomes.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllOpenHomes.fulfilled, (state, action) => {
        const {current_page, data, ...rest} = action.payload;
        if (action.meta.arg.page === 1) {
          state.openHomesData = {current_page, data, ...rest};
        } else {
          state.openHomesData = {
            ...state.openHomesData,
            data: [
              ...state.openHomesData.data,
              ...data.filter(
                (item) =>
                  !state.openHomesData.data.some(
                    (existing) => existing.id === item.id
                  )
              ),
            ],
            ...rest,
          };
        }
        state.loading = false;
        state.openHomesDataError = null;
      })
      .addCase(getAllOpenHomes.rejected, (state, action) => {
        state.loading = false;
        state.openHomesDataError = action.payload;
        state.openHomesData = initialState.openHomesData;
      })

      .addCase(getOpenHomeById.pending, (state) => {
        state.loadingAttendees = true;
      })
      .addCase(getOpenHomeById.fulfilled, (state, action) => {
        const {data, page} = action.payload;
        if (page === 1) {
          state.attendees = data;
        } else {
          state.attendees.data = [
            ...state.attendees.data,
            ...data.data.filter(
              (item) =>
                !state.attendees.data.some(
                  (existing) => existing.id === item.id
                )
            ),
          ];
          state.attendees.current_page = data.current_page;
          state.attendees.next_page_url = data.next_page_url;
          state.attendees.total = data.total;
        }
        state.loadingAttendees = false;
        state.attendeesError = null;
      })
      .addCase(getOpenHomeById.rejected, (state, action) => {
        state.loadingAttendees = false;
        state.attendeesError = action.payload;
      });
  },
});
export const {setFormSubmitLoading, setTabIndex} = openHomeSlice.actions;
export default openHomeSlice.reducer;
